import axios from 'axios';
import '../../global';

export const FETCH_MEETINGS = 'FETCH_MEETING';
export const SEARCH_COMMITTEES = 'SEARCH_COMMITTEES';
export const POLICY_GROUP_FILTER = 'POLICY_GROUP_FILTER';
export const SWITCH_TAB    = 'SWITCH_TAB';
export const FETCH_DOCUMENTS = 'FETCH_DOCUMENTS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_AGENDA = 'SET_AGENDA';
export const SET_MEETING_ID = 'SET_MEETING_ID';
export const LOADING_DOCUMENT = 'LOADING_DOCUMENT';
export const POPUP_ERROR = 'POPUP_ERROR';
export const OPEN_URL    = 'OPEN_URL';
export const GENERATING_DOCUMENT = 'GENERATING_DOCUMENT';
export const SET_DIAL_IN = 'SET_DIAL_IN';
export const MEETING_INVITE = 'MEETING_INVITE';
export const SET_LOADING = 'SET_LOADING';
export const REMOVE_LOADING   = 'REMOVE_LOADING';
export const SET_COMMITTEE_CODE_SEARCH = 'SET_COMMITTEE_CODE_SEARCH';
export const COMMITTEE_DOCUMENTS = 'COMMITTEE_DOCUMENTS';
export const DOCUMENT_FILTER_TYPE = 'DOCUMENT_FILTER_TYPE';
export const CATEGORY_FILTER_TYPE = 'CATEGORY_FILTER_TYPE';
export const SET_DOCUMENT_PAGINATION = 'SET_DOCUMENT_PAGINATION';
export const SET_GO_TO_MEETING = 'SET_GO_TO_MEETING';
export const DOCUMENT_TAGS = 'DOCUMENT_TAGS';
export const CURRENT_DOCUMENT_TOPICS = 'CURRENT_DOCUMENT_TOPICS';
export const REMOVE_DOCUMENT_TOPIC = 'REMOVE_DOCUMENT_TOPIC';

export function fetchUpcomingMeetings(min = 0, max = 50) {
	return ( dispatch ) => {
		'use strict';


		fetchCommitteeToken.then( (committeeToken) => {
			const url = `${getCommitteeUrl()}/meetings`;
			const myCommittees = getMyCommittees();
			const urlParams = {};
			const config = api_config( committeeToken );
			var meetings = '';
			myCommittees.forEach((committee, element) => {
				const paramElement  = 'ccode['+element+']';
				const paramValue    =  committee.code ;
				urlParams[paramElement] = paramValue;
			});
			urlParams['min'] = min;
			urlParams['max'] = max;
			const payload = serialize(urlParams);

			axios.post( url, payload, config ).then( response => {
				meetings = response.data;

				if ( meetings.length === 0 ) {
					//This means that there is no more meetings to be requested at this time.
					dispatch( setPagination( 'END_PAGINATION' ) );
					return 0;
				}
				dispatch( {
					          type: FETCH_MEETINGS, payload: response.data
				          } );
				// function also executes fetch documents
				dispatch( fetchDocuments( meetings ) );
				let paginationParams = {
					status: true, min: min + max, max: max
				}
				dispatch( setPagination( paginationParams ) );

			} );

		}).catch(function(error) {
			console.log(error)
		});
	};
}

export function fetchDocumentTags(){
	return ( dispatch ) => {
		'use strict';

		fetchCommitteeToken.then( (committeeToken) => {
			const url = `${getCommitteeUrl()}/documents/tags`;
			const config = api_config( committeeToken );

			axios.get( url,config ).then( response => {
				dispatch( {
						          type: DOCUMENT_TAGS, payload: response.data
					          } );
				}).catch(function(error) {
					console.log(error)
				});
		});
	}
}

export function setCommitteeCode(ccode) {
	return ( dispatch ) => {
		dispatch( {
			          type: SET_COMMITTEE_CODE_SEARCH, payload: ccode
		          } )
	}
}

export function setPagination(paginationParams){
	return (dispatch) =>{
		dispatch({
			type:SET_PAGINATION,
			payload: paginationParams
        })

	}
}

export function setDocumentPagination(paginationParams){
	return (dispatch) =>{
		dispatch({
			type:SET_DOCUMENT_PAGINATION,
			payload: paginationParams
        })

	}
}

export function setAgendaState(meetID){
	return (dispatch) => {
		dispatch({
			type:SET_AGENDA,
			payload: meetID
		});
	}
}

export function fetchDocuments(meetings){
	return (dispatch) => {
		'use strict';
		fetchCommitteeToken.then( (committeeToken) => {
			const url = `${getCommitteeUrl()}/documents/`;
			const urlParams = {};
			meetings.forEach( ( meeting, element ) => {
				const paramElement  = 'meeting_id[' + element + ']';
				const paramValue    =  meeting.ID;
				urlParams[paramElement] = paramValue;
			} );
			const payload = serialize(urlParams);
			const config = api_config( committeeToken );

			axios.post( url, payload, config ).then( response => {
				//fetch committee Documents here.
				fetchCommitteeDocuments(response);
				dispatch( {
					          type: FETCH_DOCUMENTS, payload: response.data
				          } );
			} );
		}).catch(function(error) {
			console.log(error)
		});
	}
}

export function fetchCommitteeDocuments(min = 0, max = 50){
	return (dispatch) => {
		'use strict';
		fetchCommitteeToken.then((committeeToken) => {
			const url = `${getCommitteeUrl()}/documents/committee-documents`;
			const urlParams = {};
			const committees = getMyCommittees();
			committees.forEach( ( ccode, element ) => {
				const paramElement  = 'ccode[' + element + ']';
				const paramValue    =  ccode.code;
				urlParams[paramElement] = paramValue;
			} );
			urlParams['min'] = min;
			urlParams['max'] = max;
			const payload = serialize(urlParams);
			const config = api_config( committeeToken );


			axios.post( url, payload, config ).then( response => {
				if(response.data.length === 0){
					dispatch(setDocumentPagination('END_PAGINATION'));
					return 0;
				} else{
						dispatch({
							         type:COMMITTEE_DOCUMENTS,
							         payload:response.data
	          })
				}

			let paginationParams = {
				status: true, min: min + max, max: max
			}
			dispatch( setDocumentPagination( paginationParams ) );

			} );

		});

	}

}

export function setGoToMeeting(meeting_id){
	return (dispatch) => {
		dispatch({
			type:SET_GO_TO_MEETING,
			payload:meeting_id
    });

	}
}

export function setMeetingID(){
	return (dispatch) => {

		dispatch({
			type:SET_MEETING_ID,
			payload: get_meeting_id()
		         });
	}
}

export function switchTabDispatch(tabName){
	return (dispatch) => {
		dispatch( {
			          type: SWITCH_TAB,
			          payload : tabName
		          } );
	}
}

export function isUserLoggedIn(){
	return containsClass( document.body, 'logged-in' );
}

export function searchFunction(keyword){
	return (dispatch) => {

		dispatch({
			         type:SEARCH_COMMITTEES,
			         payload: keyword
		         });
	}
}

export function containsClass( elem, yourClass ) {
	if ( !elem || typeof yourClass !== 'string' ) {
		return false;
	} else if ( elem.className && elem.className.trim()
	                                  .split( /\s+/gi )
	                                  .indexOf( yourClass ) > -1 ) {
		return true;
	} else {
		return false;
	}
}



const fetchCommitteeToken = new Promise (function (resolve, reject) {
	if ( !isUserLoggedIn() ) {
		return 0;
	}

	var committeeToken = '';
	var userStorageEmail = localStorage.getItem( 'tokenEmail' );
	var currentEmail = getImisInfo().UserName;

	if ( localStorage.getItem( 'committeeToken' ) && (userStorageEmail === currentEmail) ) {
		committeeToken = localStorage.getItem( 'committeeToken' );
		resolve( committeeToken );
	} else {

		const urlParams = {};
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/auth`;
		const imisInfo = getImisInfo();

		for ( let element in imisInfo ) {
			const paramElement  = element;
			const paramValue    = imisInfo[ element ];
			urlParams[paramElement] = paramValue;
		}
		const payload = serialize(urlParams);

		axios.post( url, payload ).then( response => {

			committeeToken = response.data.token;
			setTokenLocalStorage(committeeToken,currentEmail);
			resolve( committeeToken );

		} ).catch((error)=> {
			console.log(error);
			reject(false);
		});
	}
});




function api_config(token){
	let config = {
		headers: {
			'Authorization': 'Bearer ' + token
		}
	}
	return config;
}

export function downloadDocument(file_name,download_file_name,document_id){
		return (dispatch) => {
			fetchCommitteeToken.then( ( committeeToken ) => {
				const url = `${getCommitteeUrl()}/documents/generate-url`;
				const urlParams = {};
				const config = api_config( committeeToken );
				urlParams[ 'file_name' ]          = file_name;
				urlParams[ 'download_file_name' ] = download_file_name;
				const payload = serialize( urlParams );
				dispatch(documentLoading(file_name));
				axios.post( url, payload, config ).then( response => dispatch(openWindow(response.data)) );
				requestLogDownload(document_id);
			} ).catch( function( error ) {
				console.log( error );
			} );
		}
}

function requestLogDownload(document_id){
	fetchCommitteeToken.then( ( committeeToken ) => {
		const url = `${getCommitteeUrl()}/documents/log-download`;
		const urlParams = {};
		const config = api_config( committeeToken );
		urlParams[ 'document_id' ] = document_id;
		const payload = serialize( urlParams );
		axios.post( url, payload, config ).then( response => console.log(response) );
	}).catch( function( error ) {
		console.log( error );
	} );
}

function documentLoading(file_name){
	return {payload:file_name, type:'GENERATING_DOCUMENT'};
}

function openWindow(url){
	const open_url = url;
	location.href = open_url;
	return {payload:'',type: 'GENERATING_DOCUMENT'}
}

export function getAgendaPDF(meeting_id){
	return (dispatch) => {

		const urlParams = {};
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/documents/download-agenda`;
		urlParams['meeting_id'] = meeting_id;
		const payload = serialize(urlParams);
		fetchCommitteeToken.then( (committeeToken) => {
			let config = api_config( committeeToken );
			axios.post( url, payload, config ).then( response => {
				dispatch(setDocumentLoading());
				const agendaurl = response.data;
				let windowOpen = window.open(agendaurl);
				if(windowOpen === null || !windowOpen || windowOpen.closed || typeof windowOpen.closed=='undefined'){
					dispatch(popUpError(meeting_id));
				} else{
					dispatch(popUpError());
					setTimeout(function(  ) {
						unlinkDocument(agendaurl);

					},2000);
				}

			});
		}).catch(function(error) {
			console.log(error);
		});
	}

}

export function popUpError(meeting_id = ''){
	return (dispatch) => {
		dispatch({
			type:POPUP_ERROR,
			payload: meeting_id
		         })
	}
}

export function setDialInState(meetID){
	return (dispatch) => {
		dispatch({
			         type:SET_DIAL_IN,
			         payload: meetID
		         });
	}
}



export function setDocumentLoading(meeting_id = ''){
	return (dispatch) => {
		dispatch({
			         type:LOADING_DOCUMENT,
			         payload: meeting_id
		         });
	}

}

export function rsvpUser(ccode, meeting_id, attendance){
	return (dispatch) => {
		const urlParams = {};
		const committeeUrl = getCommitteeUrl();
		const url = `${committeeUrl}/rsvp/`;
		urlParams['meet_id'] = meeting_id;
		urlParams['ccode'] = ccode;
		urlParams['email'] = getImisInfo().UserName.toLowerCase();
		urlParams['attendance_type'] = attendance;
		const payload = serialize(urlParams);
		fetchCommitteeToken.then( (committeeToken) => {
			let config = api_config( committeeToken );
			axios.post( url, payload, config ).then( response => {
			console.log(response);
			//todo check response

			});
		}).catch(function(error) {
			console.log(error);
		});
	}

}

export function getCalendarInvite(meeting_id,ccode,loading_id){
	return (dispatch) => {
		fetchCommitteeToken.then( ( committeeToken ) => {
			'use strict';
			const config = api_config( committeeToken );
			const url = `${getCommitteeUrl()}/invites/`;
			const urlParams = {};
			urlParams[ 'ccode' ] = ccode;
			urlParams[ 'meeting_id' ] = meeting_id;
			urlParams[ 'email' ] = getImisInfo().UserName;
			const payload = serialize( urlParams );

			axios.post( url, payload, config )
			     .then( response => {

				     //todo if response success.
				     dispatch({
					              type:REMOVE_LOADING,
					              payload: loading_id
				              });

				     dispatch({
					              type:MEETING_INVITE,
					              payload: {meeting_id,
						              'status':response.status
					              }
				              });
			     })
		} ).catch(function(error){
			console.log(error);
		});
	}
}

export function setLoadingState(code){
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: SET_LOADING, payload: code } );
	}
}

export function setDocumentType(documentType){
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: DOCUMENT_FILTER_TYPE, payload: documentType } );
	}
}
export function setCategoryType(categoryType){
	return ( dispatch ) => {
		'use strict';
		dispatch( { type: CATEGORY_FILTER_TYPE, payload: categoryType} );
	}
}

export function setCurrentDocumentTopics(topic){
	return (dispatch) => {
		'use strict';
		dispatch({type:CURRENT_DOCUMENT_TOPICS, payload:topic})
	}
}

export function removeDocumentTopic(topic){
	return (dispatch) => {
		'use strict';
		dispatch({type:REMOVE_DOCUMENT_TOPIC,payload:topic});
	}
}

